<template>
    <div class="index-about">
        <div class="index-about-title" :class="{active:isActive}" ref="aboutTitle">
            <p class="index-about-title-zh" :class="{active:isActive}">{{$t('navBar.contact')}}</p>
            <p class="index-about-title-en" v-show="$i18n.locale==='zh'">ABOUT US</p>
        </div>
        <div class="index-about-content" :class="{active:isActive}" ref="aboutContent">
            {{ $t(`aboutUs.introduce`)}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "about",
        data(){
            return {
                isActive:false,
                name:'about'
            }
        },
        mounted(){
            if(this.$route.fullPath==='/#about'&&!this.isActive) {
                setTimeout(() => {
                    this.isActive = true
                }, 100)
            }
        },
        watch:{
            '$route.fullPath'(){
                if(this.$route.fullPath==='/#about'&&!this.isActive) {
                    setTimeout(() => {
                        this.isActive = true
                    }, 100)
                }
            }
        }
    }
</script>

<style scoped lang="scss" src="./about.scss">

</style>
